









import { Component, Prop, Vue } from 'vue-property-decorator';

import * as _ from 'lodash';

@Component
export default class GuessBoard extends Vue {
    get selectNumberList() {
        const level = this.$store.getters.getLevel();
        const selectedNumbers: string[] = this.$store.getters.getSelectedNumbers();
        return _.concat(selectedNumbers, _.fill(Array(level - selectedNumbers.length), '')).map((n, i) => {
            return {
                index: i,
                value: n,
                x: 50 * i,
                y: 50,
            };
        });
    }
}
